import * as React from 'react';
import { Checkbox } from 'omakase';
import ConsumerDisplayMoney from 'components/ConsumerDisplayMoney';

interface GiftCardBalanceApplyProps {
  amountCents: number;
  onChange(event: React.ChangeEvent<HTMLInputElement>, checked: boolean): void;
  useGiftCardBalance: boolean;
}

export const GiftCardBalanceApply: React.FunctionComponent<GiftCardBalanceApplyProps> = ({
  amountCents,
  onChange,
  useGiftCardBalance,
}) => {
  return (
    <Checkbox
      data-testid="gift-card-balance-apply"
      name="useBalance"
      id="useBalance"
      checked={useGiftCardBalance}
      onChange={onChange}
      value={useGiftCardBalance}
      label={
        <>
          Use your{' '}
          <strong>
            <ConsumerDisplayMoney amount={amountCents} />{' '}
          </strong>
          balance
        </>
      }
    />
  );
};
